<template>
  <div class="transaction-button">
    <transaction-progress-button
      @click="onClick"
      :text="text"
      :disabled="disabled"
      v-if="isProgress"
    />
    <transaction-not-progress-button
      @click="onClick"
      :text="text"
      :disabled="disabled"
      v-else
    />
  </div>
</template>

<script>
import TransactionProgressButton from "@/views/enterprise/addon/operation/components/buttons/InvokeButton";
import TransactionNotProgressButton from "@/views/enterprise/addon/operation/components/buttons/RevokeButton";
import enterpriseWorkflowService from "@/services/enterprises/enterpriseWorkflowService";

const EVENTS = {
  CLICK: "click",
};

export default {
  name: "TransactionButtonContainer",

  components: {
    TransactionProgressButton,
    TransactionNotProgressButton,
  },

  props: {
    transaction: {
      type: Object, // EnterpriseWorkflowTransaction
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    isProgress() {
      return enterpriseWorkflowService.isTransactionProgress(this.transaction);
    },
    text() {
      return this.transaction.label;
    },
  },

  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
